import { render } from "./TeacherEdit.vue?vue&type=template&id=ee5c1b08&scoped=true"
import script from "./TeacherEdit.vue?vue&type=script&lang=js"
export * from "./TeacherEdit.vue?vue&type=script&lang=js"

import "./TeacherEdit.vue?vue&type=style&index=0&id=ee5c1b08&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee5c1b08"]])

export default __exports__